import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: {},
  error: "", // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
  // true khi lỗi đăng nhập là do tài khoản có trạng thái Locked (backend trả 403 Forbidden) — mục
  // 8.5, READE.md — dùng để hiển thị message riêng cạnh nút Đăng nhập thay vì Alert lỗi chung.
  isAccountLocked: false,
};

const loginSlice  = createSlice({
  name: "login",
  initialState,
  reducers: {
        apiError(state, action) {
      // action.payload có thể là string (các luồng khác: logout/social login/reset flag) hoặc
      // { message, isAccountLocked } (loginUser — phân biệt lỗi do tài khoản bị khóa)
      const payload = action.payload;
      const isObjectPayload = payload && typeof payload === 'object';
      state.error = isObjectPayload ? payload.message : payload;
      state.isAccountLocked = isObjectPayload ? !!payload.isAccountLocked : false;
      state.loading = false;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload
      state.loading = false;
      state.errorMsg = false;
      state.isAccountLocked = false;
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true
    },
    reset_login_flag(state) {
      state.error = "";
      state.loading = false;
      state.errorMsg = false;
      state.isAccountLocked = false;
    }
  },
});

export const {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag
} = loginSlice.actions

export default loginSlice.reducer;